import { React, useState } from "react";
import useConfiguration from "../../../../hooks/useConfiguration";
import Checkbox from "../../../common/Checkbox";
import { useDispatch } from "react-redux";
import useSessionStorage from "../../../../hooks/useSessionStorage";
import requestUtil from "../../../../helpers/requestUtil";
import {
  setLoadingPageFalse,
  setLoadingPageTrue,
} from "../../../common/Loader/action";
import {
  clearData,
  dataReset,
  getCandidateRating,
  getCandidateSearchViewDetail,
  getEmployerCommentsHistory,
  loadMasterData,
  sendMailToCandidateNoUploadCertificate,
  updateQAData,
} from "./action";
import * as Toasts from "../../../common/Toastify";
import { candidateSearchViewSelector } from "./selector";
import ModalWithPagination from "../../../common/Modal/modalWithPagination";
import { useSelector } from "react-redux";
import { useRef } from "react";
import moment from "moment";
import Modal from "../../../common/Modal/modal";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { localHostBaseURL } from "../../../../helpers/domainURL";
import { setLoadingFlagDecrement, setLoadingFlagIncrement } from "./slice";

export default (props) => {
const {qaTabDuplicateDataV2} = useSelector(candidateSearchViewSelector);
  const location = useLocation();
  const { userData } = location.state || {};
  const { qaTabDynamicDataV2 } = props;
  const config = useConfiguration();
  const baseUrl = config.baseUrl;
  const dispatch = useDispatch();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [candidateIdpram, setcandidateIdpram] = useState(0);
  const [errors, setErrors] = useState([]);
  const [updatedValue, setupdatedValue] = useState({
    CandidateProfileFormValueId: "",
    CandidateId: "",
    EmployerId: "",
    CandidateProfileFormId: "",
    FormSectionId: "",
    FormControlId: "",
    ValidationState: "",
    Notes: "",
    ValidatedBy: "",
  });
  const [checkedvalue, setcheckedvalue] = useState(false);
  const [checkboxVal, setCheckboxVal] = useState([]);

  const [certificationValidationId, setCertificationValidationId] = useState()

    // Send Mail for certifications Part (While click "No" in Upload section open a Popup)
    const [mailPopup, setMailPopup] = useState(false);

      // Send Mail for certifications No upload get a Input Message
    const [mailPopupText, setMailPopupText] = useState();

      // Send Mail for mail popup input Error Validation
  const [errorMailPopupText, setErrorMailPopupText] = useState();

    // Send Mail popup open function
    const sendMailModalOpen = (validationId, tabId, sectionId) => {
      setMailPopup(true);
      setCertificationValidationId({validationId, tabId, sectionId});
    }
  

    // Send Mail popup open function
    const sendMailModalClose = () => {
      // dispatch(
      //   getCandidateSearchViewDetail({
      //     url: `${config.baseUrl}/Candidates/get-candidate-infoV2`,
      //     candidateUniqueId: props?.userData?.candidateUniqueId,
      //     employerUniqueId: login.employerUniqueId,
      //   })
      // );

      setMailPopup(!mailPopup);
      setErrorMailPopupText("")
      setMailPopupText("")

      // Current Onchange Value
      const updateVal = JSON.parse(JSON.stringify(qaTabDynamicDataV2));
      // Duplicate Value
      const newUpdateVal = JSON.parse(JSON.stringify(qaTabDuplicateDataV2));

      // Declere a Value 
      let validationStateValue;
      let validationStateYes;
      let validationStateNo;

      // get a old value
      newUpdateVal?.forEach((item) => {
        if (item?.tabId === certificationValidationId.tabId) {
          item?.sections?.forEach((item2) => {
            if (item2?.sectionId === certificationValidationId.sectionId) {
              item2?.fields?.forEach((val) => { 
                  if (val?.id === certificationValidationId.validationId) {
                    validationStateValue = val.validationState
                    validationStateYes = val.validationStateYes
                    validationStateNo = val.validationStateNo
                  }
                })
              }  
          })
        }
      })


      updateVal?.forEach((item) => {
        if (item?.tabId === certificationValidationId.tabId) {
          item?.sections?.forEach((item2) => {
            if (item2?.sectionId === certificationValidationId.sectionId) {
              item2?.fields?.forEach((val) => {
                if (val?.id === certificationValidationId.validationId) {
                    val.validationState = validationStateValue
                    val.validationStateYes = validationStateYes
                    val.validationStateNo = validationStateNo
                }
              });
            }
          });
        }
      });

      dispatch(updateQAData(updateVal));


    }

  // Send Mail popup API Method
  const sendMailToCandidateNoUploadcertificate = () => {
    if (mailPopupText?.length > 0) {
      dispatch(
        sendMailToCandidateNoUploadCertificate(
          `${config.baseUrl}`,
          props?.userData?.candidateUniqueId,
          mailPopupText,
          window.location.hostname
        )
      )


      if (userData && userData.candidateUniqueId) {
        const candidateRatingJson = {
          candidateUniqueId: userData.candidateUniqueId,
          jobUniqueId: "",
          locationId: 0,
          employerUniqueId: login.employerUniqueId,
        };
  
        dispatch(
          loadMasterData(`${config.baseUrl}`, login.employerUniqueId)
        ).then(() => {
          dispatch(
            getCandidateSearchViewDetail({
              url: `${config.baseUrl}/Candidates/get-candidate-infoV2`,
              candidateUniqueId: userData.candidateUniqueId,
              employerUniqueId: login.employerUniqueId,
            })
          ).then(() => {
            dispatch(
              getCandidateRating({
                url: `${config.baseUrl}/Employers/get-candidate-rating_for_employer`,
                params: candidateRatingJson,
              })
            );
          });
          props?.getCandidateLocationStatusList(location.state.loctionId);
        })
      }

      sendMailModalClose();
      saveValidateInfo();
      setErrorMailPopupText("")
      setMailPopupText("")
    } else {
      setErrorMailPopupText("Please fill this field")
    }
  }

  const handleChange_Notes = (target, tabId, sectionId, id) => {
    const { value } = target;
    if (value.length > 100) {
      return value;
      ///setErrors("Notes should be a 10 digit number");
    }
    const updateVal = JSON.parse(JSON.stringify(qaTabDynamicDataV2));
    updateVal?.forEach((item) => {
      if (item?.tabId === tabId) {
        item?.sections?.forEach((item2) => {
          if (item2?.sectionId === sectionId) {
            item2?.fields?.forEach((val) => {
              if (val?.id === id) {
                if (value !== "") {
                  val.notes = value;
                } else {
                  val.notes = "";
                }
              }
            });
          }
        });
      }
    });
    dispatch(updateQAData(updateVal));
  };
  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10) + "T00:00:00";

  const handleChange = (target, tabId, sectionId, id) => {
    const { value, checked } = target;
    const updateVal = JSON.parse(JSON.stringify(qaTabDynamicDataV2));
    updateVal?.forEach((item) => {
      if (item?.tabId === tabId) {
        item?.sections?.forEach((item2) => {
          if (item2?.sectionId === sectionId) {
            item2?.fields?.forEach((val) => {
              const dates = val?.noOfAttachments?.map((item) => item?.expirationDate)
              if (val?.id === id) {
                if (checked) {
                  if (value === "validationyes") {
                    val.validationStateYes = 1;
                    val.validationStateNo = 0;
                    val.validationState = 1;
                  } else if (value === "validationno") {
                    val.validationStateNo = 1;
                    val.validationStateYes = 0;
                    val.validationState = 0;
                  }
                } else {
                  if (value === "validationyes") {
                    val.validationStateYes = 0;
                    if (val.validationStateNo === 0) {
                      val.validationState = null;
                    } else val.validationState = 0;
                  } else if (value === "validationno") {
                    val.validationStateNo = 0;
                    if (val.validationStateYes === 0) {
                      val.validationState = null;
                    } else val.validationState = 1;
                  }
                }

                if (dates.some(date => date < formattedDate)) {
                  if (value === "validationyes") {
                    val.validationStateYes = 0;
                    if (val.validationStateNo === 0) {
                      val.validationState = null;
                    } else val.validationState = 0;
                  }
                  toast.warn("Uploaded file already expired")
                }
               
              }
            });
          }
        });
      }
    });
    dispatch(updateQAData(updateVal));
  };

  const saveValidateInfo = () => {
    const postData = [];
    const updateVal = JSON.parse(JSON.stringify(qaTabDynamicDataV2));
    updateVal?.forEach((item) => {
      item?.sections?.forEach((item2) => {
        item2?.fields?.forEach((val) => {
          if (val.isValidateRequired === true) {
            postData.push({
              employerCandidateProfileFormValueId:
                val?.employerCandidateProfileFormValueId,
              candidateProfileFormValueId: val?.candidateProfileFormValueId,
              candidateProfileFormId: val?.candidateProfileFormId,
              formSectionId: val?.formSectionId,
              formControlId: val?.formControlId,
              validationState: val?.validationState,
              isActive: true,
              notes: val?.notes,
            });
          }
        });
      });
    });
    if (updateVal && updateVal?.length > 0 && updateVal[0]?.candidateUniqueId) {
      dispatch(setLoadingPageTrue());
      requestUtil(
        `${config.baseUrl}/Jobs/saveemployerscandidatesprofileformsvalues`,
        "POST",
        {
          candidateUniqueId: updateVal[0]?.candidateUniqueId,
          employerUniqueId: login.employerUniqueId,
          appuserUniqueId: login.appUserUniqueId,
          employersCandidatesProfileFormDetails: [...postData],
        }
      )
        .then((response) => {
          setMessage(response.message);
          Toasts.success("Added personal form validations");
          dispatch(setLoadingPageFalse());
        })
        .then(() => {
          const candidateRatingJson = {
            candidateUniqueId: userData.candidateUniqueId,
            jobUniqueId: "",
            locationId: 0,
            employerUniqueId: login.employerUniqueId,
          };
          dispatch(
            loadMasterData(`${config.baseUrl}`, login.employerUniqueId)
            )
            dispatch(
              getCandidateSearchViewDetail({
                url: `${config.baseUrl}/Candidates/get-candidate-infoV2`,
                candidateUniqueId: props?.userData?.candidateUniqueId,
                employerUniqueId: login.employerUniqueId,
              })
            ).then(() => {
              dispatch(
                getCandidateRating({
                  url: `${config.baseUrl}/Employers/get-candidate-rating_for_employer`,
                  params: candidateRatingJson,
                })
              );
            });
            props?.getCandidateLocationStatusList(location.state.loctionId);
            })
        .catch((error) => {
          setErrorMessage(
            error.message || "Failed to update personal validations"
          );
          Toasts.error("Failed to update personal form validations");
          dispatch(setLoadingPageFalse());
        });
    }
  };

  // Employer History Modal Show
  const [employersHistoryModalShow, setEmployersHistoryModalShow] =
    useState(false);
  // Employer Comments History get from Selector
  const { EmployerCommentsHistory } = useSelector(candidateSearchViewSelector);
  // Employer Comments History Pagination Part start
  const EmpcommentsHistoryData = EmployerCommentsHistory?.employersComments;
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageNum, setCurrentPageNum] = useState(1);
  const [goTo, setGoTo] = useState("");
  const dataPerPage = useRef(5);
  const pageNumber = [];
  for (
    let i = 1;
    i < Math.ceil(EmpcommentsHistoryData?.length / dataPerPage.current) + 1;
    i++
  ) {
    pageNumber.push(i);
  }
  const indexOfLastItem = dataPerPage.current * currentPage;
  const indexOfCurrentItem = indexOfLastItem - dataPerPage.current;
  const EmpcommentsHistory = EmpcommentsHistoryData?.slice(
    indexOfCurrentItem,
    indexOfLastItem
  );

  // Employer Comments History Page dispatch
  const handleClickEmpHistory = ({
    candidateUniqueId,
    employerUniqueId,
    employerCandidateProfileFormValueId,
  }) => {
    dispatch(
      getEmployerCommentsHistory({
        baseUrl,
        candidateUniqueId,
        employerUniqueId,
        employerCandidateProfileFormValueId,
      })
    );
    ToogleClick();
  };

  // Modal Close Btn Page Form and Value Reset function
  const ModalClosePage = () => {
    setCurrentPage(1);
    setCurrentPageNum(1);
    setGoTo("");
  };

  // Close Modal function For Employers Comments History
  const closeEmployersCommentsModal = (e) => {
    e.preventDefault();
    setEmployersHistoryModalShow(!employersHistoryModalShow);
    ModalClosePage();
  };

  // Open Modal function for Employers Comments History
  const ToogleClick = () => {
    setEmployersHistoryModalShow(!employersHistoryModalShow);
  };
  const downloadQACertification = async (attachmentFileId, fileName) => {
    const requestHeaders = {
      "Content-Type": "application/json",
      Authorization: login.accessToken ? `Bearer ${login.accessToken}` : "",
      "Website-Domain-Name":
        window.location.hostname === "localhost"
          ? localHostBaseURL
          : window.location.hostname ,
    };
    const params = {
      candidateUniqueId: userData?.candidateUniqueId ?? "",
      attachmentFileId: parseInt(attachmentFileId) ?? 0,
    };
    try {
      dispatch(setLoadingFlagIncrement());
      
      const response = await fetch(
        `${config.baseUrl}/Employers/get-employer-QA-file-download`,
        {
          headers: { ...requestHeaders },
          method: "POST",
          body: JSON.stringify(params),
        }
      );
      const blob = await response.blob();
      let downnloadURL = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = downnloadURL;
      a.download = fileName;
      a.click();
    } catch (error) {
      Toasts.error(error.message);
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
  return (
    <>
    {/* Upload Section While clicking "No" open a Modal box Send Mail */}
    {
                              mailPopup && (
                                  <Modal
                                    showHide={() => sendMailModalClose()}
                                    label={"Compose Mail"}
                                    size={"lg"}
                                    buttonName={"Send"}
                                    saveFunction={sendMailToCandidateNoUploadcertificate}
                                  >
                                  <div className="d-flex flex-column gap-3">
                                    <span className="mx-2">
                                      Dear {" "} {props?.data?.firstName} {props?.data?.lastName},
                                    </span>
                                    <textarea className="form-control" style={{height: "100px"}} onChange={(e) => setMailPopupText(e.target.value)}/>
                                    <span className="text-danger">{errorMailPopupText}</span>
                                  </div>
                                  </Modal>
                                )
                          }
      {/* Modal Show for Employers Comments History */}
      {employersHistoryModalShow && (
        <ModalWithPagination
          showHide={closeEmployersCommentsModal}
          label={"Employers Comments History"}
          size="lg"
          onlyClose={true}
          modalClass={"rounded-2"}
          pageNumber={pageNumber}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          currentPageNum={currentPageNum}
          setCurrentPageNum={setCurrentPageNum}
          setGoTo={setGoTo}
          goTo={goTo}
        >
          <div className="card-body">
            <div>
              <ul className="list-group ">
                {EmpcommentsHistory?.map((history) => {
                  return (
                    <li className="list-group-item d-flex justify-content-between">
                      {" "}
                      <span>{history.comment}</span>{" "}
                      <div className="d-flex flex-column">
                        <span style={{ fontSize: "12px" }}>
                          {history.commentByName}
                        </span>
                        <span style={{ fontSize: "12px" }}>
                          {history.commentDateToDisplay}
                        </span>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </ModalWithPagination>
      )}
      {qaTabDynamicDataV2 &&
        qaTabDynamicDataV2?.map((itemVal) => (
          <div className="col-md-12 col-xl-12">
            <div className="card">
              <div className="col-lg-12 col-md-12">
                <div className="row">
                  <div className="card-header">
                    <div className="PrintHeader">
                      {<h3>{itemVal?.tabDisplayName}</h3>}
                    </div>
                  </div>
                </div>
              </div>
              <br></br>
              {itemVal?.sections?.map((item) => {
                return (
                  <div className="col-md-12 col-xl-12">
                    <div className="card">
                      <div className="col-lg-12 col-md-12">
                        <div className="row">
                          <div className="card-header">
                            <div className="PrintHeader">
                              <h3> {item?.sectionHeading}</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {item?.isValidateRequired === false ? (
                        <></>
                      ) : (
                        <>
                          <br></br>
                          <div className={"row"}>
                            <div className="col-3 d-flex justify-content-center align-items-center"></div>
                            <div className="col-2 d-flex justify-content-center align-items-center">
                              Expiration Date
                            </div>
                            <div className="col-1 d-flex justify-content-center align-items-center">
                              Answers
                            </div>
                            <div className="col-1 d-flex justify-content-center align-items-center">
                              Uploads
                            </div>
                            <div className="col-2 d-flex justify-content-center align-items-center">
                              Validate Uploads
                            </div>
                            <div className="col-3 d-flex justify-content-start align-items-center">
                              Notes
                            </div>
                          </div>{" "}
                        </>
                      )}
                      <div className="card-body">
                        <div className="col-lg-12 col-md-12">
                          {item?.fields?.map((val) => {
                            return (
                              <div className={"row"}>
                                <div className="expanel expanel-default">
                                  <div className="expanel-body mb-0">     
                                    {val?.isFieldsSaved === false ? (
                                      <>
                                        <div className="row">
                                          <div className="col-md-4">
                                            {" "}
                                            {val?.label}{" "}
                                          </div>

                                          {/* {
                                                                              
                                                                             val?.isUploadAttchmentValues === 'Yes'?
                                                                                   (<div className="col-md-1" style={{width:'20px;',color:'Green'}}>{val?.isUploadAttchmentValues}</div>) :
                                                                                    val?.isUploadAttchmentValues === 'No' ?
                                                                                   (<div className="col-md-1" style={{width:'20px;',color:'Red'}}>{val?.isUploadAttchmentValues}</div>):
                                                                                    (<div className="col-md-1" style={{width:'20px;',color:'Black'}}>{val?.isUploadAttchmentValues}</div>)

                                                                                    
                                                                             } */}

                                          <div className="col-md-3">
                                            {val?.isAttachmentNeeded ===
                                            false ? (
                                              <></>
                                            ) : (
                                              <>
                                                <div className="row">
                                                  <div className="col-md-3">
                                                    <div className=" custom-control custom-checkbox">
                                                      {/*                                                                                 
                                                                                 <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        name="Validateyes"
                                                                                        value={"validationyes"}
                                                                                        checked={val.validationStateYes === 1}
                                                                                        id="flexCheckDefault"
                                                                                        onChange={(e) => handleChange(e.target,itemVal.tabId,item.sectionId,val.id)}
                                                                                    />  */}
                                                      {/* <label>Yes</label> */}
                                                    </div>{" "}
                                                  </div>
                                                  <div className="col-md-1">
                                                    <div className=" custom-control custom-checkbox">
                                                      {/* <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        name="Validateno"
                                                                                        value={"validationno"}
                                                                                        checked={val.validationStateNo === 1}
                                                                                        id="flexCheckDefaultno"
                                                                                        onChange={(e) => handleChange(e.target,itemVal.tabId,item.sectionId,val.id)}
                                                                                    /> */}
                                                      {/* <label>No</label> */}
                                                    </div>{" "}
                                                  </div>
                                                </div>
                                              </>
                                            )}
                                          </div>
                                          <div className="col-md-3">
                                            {/* <textarea type="textarea" 
                                                                                        name="textValue"
                                                                                        value={val?.notes}
                                                                                        onChange={(e) => handleChange_Notes(e.target,itemVal.tabId,item.sectionId,val.id)}
                                                                                        /> */}
                                          </div>
                                        </div>
                                        {val?.noOfAttachments?.map(
                                          (valforAttachment) => {
                                            return (
                                              valforAttachment?.name && (
                                                <div>
                                                  <label htmlFor="exampleInputname1"></label>
                                                  <a
                                                  style={{cursor:"pointer"}}
                                                  onClick={() => downloadQACertification(valforAttachment?.id, valforAttachment?.name)}
                                                  // href="#"
                                                    // href={`${itemVal?.downloadUrl}/${valforAttachment?.blobName}`}
                                                    // target="_blank"
                                                    rel="noreferrer"
                                                  >
                                                    <i>
                                                      {valforAttachment?.name}
                                                    </i>
                                                    <i
                                                      className="mdi mdi-arrange-bring-forward"
                                                      data-bs-toggle="tooltip"
                                                      title=""
                                                      data-bs-original-title="mdi-arrange-bring-forward"
                                                      aria-label="mdi-arrange-bring-forward"
                                                    ></i>{" "}
                                                  </a>
                                                </div>
                                              )
                                            );
                                          }
                                        )}
                                      </>
                                    ) : 
                                    val?.selectedValue === '' || val?.selectedValue  ? 
                                    (
                                      <>
                                        <div className="row">
                                          <div className="col-md-3">
                                            {" "}
                                            {val?.label}{" "}
                                          </div>
                                          <div className="col-2 d-flex justify-content-end flex-column ">
                                            {/* {val?.noOfAttachments?.map(attachments =>{
                                              return(
                                                <>
                                                 {attachments?.expirationDate? <span className="">{moment(attachments?.expirationDate).format("MM/DD/YYYY")}</span>:""}
                                                </>
                                              )
                                              })} */}
                                          </div>
                                          {val?.selectedValue === "Yes" ? (
                                            <div
                                              className="col-1 d-flex justify-content-center "
                                              style={{
                                                width: "20px;",
                                                color: "Green",
                                              }}
                                            >
                                              {val?.selectedValue}
                                            </div>
                                          ) : val?.selectedValue === "No" ? (
                                            <div
                                              className="col-1 d-flex justify-content-center "
                                              style={{
                                                width: "20px;",
                                                color: "Red",
                                              }}
                                            >
                                              {val?.selectedValue}
                                            </div>
                                          ) : (
                                            <div
                                              className="col-1 d-flex justify-content-center "
                                              style={{
                                                width: "20px;",
                                                color: "Black",
                                              }}
                                            >
                                              {val?.selectedValue}
                                            </div>
                                          )}
                                          {/* <div className="col-md-1" style={{ height: '20px' }}>{val?.selectedValue}</div> */}
                                          {/* {
                                                                            val?.isAttachmentNeeded  ===  true ? <>
    
    {  
                                                                           val?.noOfAttachments?.map(valforAttachment => {
                                                                                return (
                                                                                    
                                                                                    valforAttachment?.name ?                                                                              
                                                                                       <div className="col-md-2" style={{height:'20px'}}>yes</div> : 
                                                                                       <div className="col-md-2" style={{height:'20px'}}>no</div>                                                                   
                                                                                )
                                                                                })}
    
    
    
                                                                           <div className="col-md-2" style={{height:'20px'}}>{val?.selectedValue}</div> 
    
                                                                             </> :<> */}
                                          {val?.isUploadAttchmentValues ===
                                          "Yes" ? (
                                            <div
                                              className="col-1 d-flex justify-content-center"
                                              style={{
                                                width: "20px;",
                                                color: "Green",
                                              }}
                                            >
                                              {val?.isUploadAttchmentValues}
                                            </div>
                                          ) : val?.isUploadAttchmentValues ===
                                            "No" ? (
                                            <div
                                              className="col-1 d-flex justify-content-center"
                                              style={{
                                                width: "20px;",
                                                color: "Red",
                                              }}
                                            >
                                              {val?.isUploadAttchmentValues}
                                            </div>
                                          ) : (
                                            <div
                                              className="col-1 d-flex justify-content-center"
                                              style={{
                                                width: "20px;",
                                                color: "Black",
                                              }}
                                            >
                                              {val?.isUploadAttchmentValues}
                                            </div>
                                          )}

                                          <div className="col-2 d-flex justify-content-center align-items-center">
                                            {val?.isAttachmentNeeded ===
                                            false ? (
                                              <></>
                                            ) : (
                                              <>
                                                <div className={"row"}>
                                                  <div className="col-6">
                                                    <input
                                                      className="checkboxView success"
                                                      type="checkbox"
                                                      name="Validateyes"
                                                      value={"validationyes"}
                                                      checked={
                                                        val.validationStateYes ===
                                                        1
                                                      }
                                                      disabled={val?.isUploadAttchmentValues === "No"}
                                                      id="flexCheckDefault"
                                                      onChange={(e) =>
                                                        handleChange(
                                                          e.target,
                                                          itemVal.tabId,
                                                          item.sectionId,
                                                          val.id
                                                        )
                                                      }
                                                    />
                                                    {val?.validationStateYes ===
                                                    1 ? (
                                                      <>
                                                        <label
                                                          style={{
                                                            width: "20px;",
                                                            color: "Green",
                                                          }}
                                                        >
                                                          Yes
                                                        </label>
                                                      </>
                                                    ) : (
                                                      <label
                                                        style={{
                                                          width: "20px;",
                                                        }}
                                                      >
                                                        Yes
                                                      </label>
                                                    )}
                                                  </div>

                                                  <div className="col-6">
                                                    <input
                                                      className="checkboxView failure"
                                                      type="checkbox"
                                                      name="Validateno"
                                                      value={"validationno"}
                                                      onClick={val.validationStateNo === 1 ? "" : () => sendMailModalOpen(val.id, itemVal.tabId, item.sectionId)}
                                                      checked={
                                                        val.validationStateNo ===
                                                        1
                                                      }
                                                      disabled={val?.isUploadAttchmentValues === "No"}
                                                      id="flexCheckDefaultno"
                                                      onChange={(e) =>
                                                        handleChange(
                                                          e.target,
                                                          itemVal.tabId,
                                                          item.sectionId,
                                                          val.id
                                                        )
                                                      }
                                                    />
                                                    {val?.validationStateNo ===
                                                    1 ? (
                                                      <>
                                                        <label
                                                          style={{
                                                            width: "20px;",
                                                            color: "Red",
                                                          }}
                                                        >
                                                          No
                                                        </label>
                                                      </>
                                                    ) : (
                                                      <label
                                                        style={{
                                                          width: "20px;",
                                                        }}
                                                      >
                                                        No
                                                      </label>
                                                    )}
                                                  </div>
                                                 
                                                </div>
                                                 
                                              </>
                                            )}
                                          </div>
                                          <div className="col-3 d-flex  justify-content-center">
                                            <textarea
                                              type="textarea"
                                              name="textValue"
                                              value={val?.notes}
                                              onChange={(e) =>
                                                handleChange_Notes(
                                                  e.target,
                                                  itemVal.tabId,
                                                  item.sectionId,
                                                  val.id
                                                )
                                              }
                                            />
                                            <button
                                              className="btn"
                                              onClick={() =>
                                                handleClickEmpHistory({
                                                  candidateUniqueId:
                                                    val.candidateUniqueId,
                                                  employerUniqueId:
                                                    val.employerUniqueId,
                                                  employerCandidateProfileFormValueId:
                                                    val.employerCandidateProfileFormValueId,
                                                })
                                              }
                                            >
                                             <i class="fa fa-history" aria-hidden="true"></i>
                                            </button>

                                            {/* <div
                                            className="btn"
                                              onClick={() =>
                                                handleClickEmpHistory({
                                                  candidateUniqueId:
                                                    val.candidateUniqueId,
                                                  employerUniqueId:
                                                    val.employerUniqueId,
                                                  employerCandidateProfileFormValueId:
                                                    val.employerCandidateProfileFormValueId,
                                                })
                                              }
                                            >
                                                View
                                            </div> */}
                                          </div>
                                        </div>
                                        {val?.noOfAttachments?.map(
                                          (valforAttachment) => {
                                            return (
                                              valforAttachment?.name && (
                                                <div className={"row"}>
                                                  <div className="col-3 ">
                                                    <a
                                                    style={{cursor:"pointer"}}
                                                      onClick={() => downloadQACertification(valforAttachment?.id, valforAttachment?.name)}
                                                      // href={`${itemVal?.downloadUrl}/${valforAttachment?.blobName}`}
                                                      // target="_blank"
                                                      rel="noreferrer"
                                                    >
                                                      <i>
                                                        {valforAttachment?.name}
                                                      </i>
                                                      <i
                                                        className="mdi mdi-arrange-bring-forward"
                                                        data-bs-toggle="tooltip"
                                                        title=""
                                                        data-bs-original-title="mdi-arrange-bring-forward"
                                                        aria-label="mdi-arrange-bring-forward"
                                                      ></i>{" "}
                                                    </a>
                                                  </div>
                                                  <div className="col-2 d-flex justify-content-center align-items-center">
                                                    {valforAttachment?.expirationDate ? (
                                                      <span className="">
                                                        {moment(
                                                          valforAttachment?.expirationDate
                                                        ).format("MM/DD/YYYY")}
                                                      </span>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </div>
                                                </div>
                                              )
                                            );
                                          }
                                        )}
                                      </>
                                    ) : (
                                      val?.selectedValueOptionsToDisplay?.map(
                                        (valtoDispay) => {
                                          return <div>{valtoDispay.name}</div>;
                                        }
                                      )
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  // <div className="card">
                  //         <div className={"row"}>
                  //         <div className='expanel expanel-default'>
                  //             <div className='expanel-body mb-0'>
                  //                         {item?.sectionHeading}
                  //                         </div>
                  //                     </div>

                  //         </div>
                  // </div>
                );
              })}

              {itemVal?.isNeedValidateButton === true ? (
                <>
                  <div className="col-lg-12 col-md-12">
                    <div className="row">
                      <div className="col-md-6"></div>
                      <div className="col-md-2"></div>
                      <div className="col-md-2"></div>
                      <div className="col-lg-2">
                        <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                          <div
                            className="btn-group me-2 sw-btn-group"
                            role="group"
                          >
                            <button
                              className="btn btn-primary sw-btn-next"
                              type="button"
                              onClick={saveValidateInfo}
                            >
                              Save Validate
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              <br></br>
            </div>
          </div>
        ))}
    </>
  );
};
